import { useState } from "react";
import { ClientMessage } from "../client-message";
import { UserMessage } from "../user-message";
import emojiIcon from "../../../../../assets/icons/emoji.svg";
import anexoIcon from "../../../../../assets/icons/anexo.svg";
import microfoneIcon from "../../../../../assets/icons/microfone.svg";
import sendIcon from "../../../../../assets/icons/send.svg";
import Picker from "@emoji-mart/react";
import data from "@emoji-mart/data";

interface ChatBoxProps {
  type: string;
}

export const ChatBox = ({ type }: ChatBoxProps) => {
  const [showEmoji, setShowEmoji] = useState(false);
  const [text, setText] = useState("");

  function handleEmojiClick(emoji: any) {
    setText(text + emoji.native);
  }

  return (
    <div className=" w-full">
      <div className="fixed bottom-0 flex max-h-[86%]  w-full flex-grow flex-col  rounded-lg  bg-white ">
        {/* desktop-md:max-h-[550px]   desktop-xl:max-h-[750px] */}
        <div className="flex flex-grow  flex-col overflow-y-auto overflow-x-hidden p-4 ">
          <ClientMessage />
          <UserMessage />
          <ClientMessage />
          <UserMessage />
          <ClientMessage />
          <UserMessage />
          <ClientMessage />
          <UserMessage />

          <ClientMessage />
          <UserMessage />
        </div>

        <div
          className={`${!showEmoji && "hidden"} absolute bottom-20 z-10 w-full`}
        >
          <Picker
            data={data}
            onEmojiSelect={handleEmojiClick}
            locale={"pt"}
            previewPosition="none"
            theme="light"
            searchPosition="none"
            categories={["frequent", "people"]}
          />
        </div>
        <div className="flex items-center justify-between gap-2  bg-primary px-2 pb-4 pt-2">
          <button type="button" className="bg-white p-4 w-full h-14 text-center text-primary font-semibold rounded-md">Iniciar conversa</button>

          {/* <div className="flex h-14 w-full items-center rounded bg-gray-100 px-2">
            <button onClick={() => setShowEmoji(!showEmoji)}>
              <img src={emojiIcon} alt="" className="mr-2 h-5 w-5" />
            </button>
            <textarea
              className="flex h-10 w-full resize-none items-center rounded bg-transparent px-2 pt-2.5 text-sm outline-none "
              placeholder="Type your message…"
              value={text}
              onChange={(e) => setText(e.target.value)}
            />
            {type !== "sms" && (
              <>
                <button onClick={() => {}}>
                  <img src={anexoIcon} alt="" className="mr-2 h-6 w-6" />
                </button>
                <button onClick={() => {}}>
                  <img src={microfoneIcon} alt="" className="mr-2 h-6 w-6" />
                </button>
              </>
            )}
          </div>
          <button className=" w-[10%]  text-center">
            <img src={sendIcon} alt="" className="mr-2 h-8 w-8" />
          </button> */}
        </div>
      </div>
    </div>
  );
};
